import { useAtomValue, useUpdateAtom } from "jotai/utils"

import { atom } from "jotai"

type UndoStackType = Array<any>

const undoStack = atom<UndoStackType>([])

export function useUndoStack<T>() {
  const value = useAtomValue(undoStack)
  const update = useUpdateAtom(undoStack)

  const initialize = () => {
    update([])
  }

  const push = (entry: T[]) => {
    update([...value, entry])
  }

  const pop = () => {
    const popped = value[value.length - 1]
    const updated = [...value.slice(0, value.length - 1)]
    update(updated)

    return popped as T[]
  }

  const length = () => value.length

  return { initialize, push, pop, length }
}
